import { Divider } from "antd";
import React from "react";

type Props = {
  title: string;
  subtitle?: string;
};

const SectionTitle = (props: Props) => {
  return (
    <div className="mb-6">
      <Divider orientation="left">
        <h2 className="text-2xl font-bold text-green-600">{props.title}</h2>
      </Divider>
      <p>{props.subtitle}</p>
    </div>
  );
};

export default SectionTitle;
